import React, { Component } from 'react';
import { NavLink, Navigate } from 'react-router-dom';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import axios from 'axios';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import BusinessIcon from '@mui/icons-material/Business';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Select from '@mui/material/Select';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import psdfimage from './images/psdfimage.png';
const useStyles = styled(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    form: {
        width: '500%',
        marginTop: theme.spacing(1),
        minWidth: 120,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default class GeneralLedgerReportSummary extends Component {
    constructor(props) {
        super();
        var strdob = new Date();
        var month = "";
        if ((strdob.getMonth() + 1) < 10) {
            month = "0" + (strdob.getMonth() + 1);
        } else {
            month = (strdob.getMonth() + 1);
        }
        const currentDate = new Date();
        var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
        var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();
        this.state = {
            logredirect: false, pagename: '', page: 0, prevpage: 0, totaldata: 0, rowsPerPage: 20, rowsPaging: [],
            search: '', id: '', order: 'desc', orderBy: 'TransactionDate', compdata: [], isblock: '', name: '',
            compemail: '', btndisabled: false,
            submitbtn: "Submit", todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: dayjs(lastDayOfMonth),
            fromdate: dayjs(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)),
            openExportDialog: false,
            fromdate1: currentDate.getFullYear() + '-' + month1 + '-' + '01', isselectdisplay: false, type: 0, report: '1',
            fromDateEnabled: false, detaileddata: [], 
            toDateEnabled: false,
            ledgerName: "",
            orderby: "le_ledgername ASC",
            ReportData: [],
        };
    }
    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({ [nam]: val });
    }
    componentWillMount() {
        document.title = "Isifol - General Ledger Summary";
        if(localStorage.getItem("ISIuserid")==null) {
            this.setState({
                redirect: true,
                pagename:'/Login'
            })
        } else {
            if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2") {
                this.fetchSummary(this.state.page, this.state.rowsPerPage);	  
            } else {
                this.PageAccessCheckApi();
            }
        }
        this.props.parentdasCallback("General Ledger Summary~");
    }
    PageAccessCheckApi() {
        axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=33')
        .then(resp => {
            let strreturn=resp.data;
            if (strreturn!==0) {
                this.fetchSummary(this.state.page, this.state.rowsPerPage);
            } else {
                this.setState({redirect: true,pagename: "/Accesspagemessage"});
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.report !== this.state.report ||
            prevState.fromdate1 !== this.state.fromdate1 ||
            prevState.todate1 !== this.state.todate1 ||
            prevState.name !== this.state.name ||
            prevState.type !== this.state.type ||
            prevState.page !== this.state.page ||
            prevState.rowsPerPage !== this.state.rowsPerPage ||
            prevState.ledgerName !== this.state.ledgerName ||
            prevState.orderby !== this.state.orderby
        ) {
          //  this.fetchSummary(this.state.page, this.state.rowsPerPage);
        }
    }
    fetchSummary = async (page, rowsPerPage) => {
        const { fromdate1, todate1, ledgerName, orderby } = this.state;
        let apiUrl = localStorage.getItem("ISIurl") + 'ajaxledger.php?action=generalledreportsummary' +
            '&fromdate=' + fromdate1 +
            '&todate=' + todate1 +
            '&cmp_id=' + localStorage.getItem('ISIcmpid') +
            '&ledgername=' + ledgerName +
            '&StartIndex=' + page +
            '&PageSize=' + rowsPerPage +
            '&orderby=' + orderby;
            const resp = await axios.get(apiUrl);
            if (resp.data.length > 0) {
                this.setState({
                    ReportData: resp.data,
                    compdata: resp.data,
                    totaldata: parseInt(resp.data[0].count),
                    detaileddata: [] 
                });
            } else {
                this.setState({ ReportData: [], compdata: [], detaileddata: [], totaldata: 0 });
            }
    };
    handleClickSearch = () => {
        this.fetchSummary(this.state.page, this.state.rowsPerPage);
    }
    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage,
            rowsPerPage: this.state.rowsPerPage
        });
    };
    Handleclickviewmore = () => {
        this.setState({ isselectdisplay: true });
    }
    handleChangeRowsPerPage = event => {
        let pageval = event.target.value;
        this.setState({
            page: 0,
            rowsPerPage: parseInt(pageval),
            prevpage: -1
        }); 
    };
    fromdatehandler = (date) => {
        if (date) {
            this.setState({
                fromdate: date,
                fromdate1: date.format('YYYY-MM-DD'),
                fromDateEnabled: true
            });
        }
    };
    todatehandler = (date) => {
        if (date) {
            this.setState({
                todate: date,
                todate1: date.format('YYYY-MM-DD'),
                toDateEnabled: true
            });
        }
    }
    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };
    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
    handleDownload = () => {
        const { ReportData } = this.state;
        const doc = new jsPDF();
        const imgWidth = 40;
        const imgHeight = 12;
        const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
        const imgY = 10;
        doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
        const title = 'General Ledger Summary Report';
        doc.setFontSize(16);
        const titleY = imgY + imgHeight + 8;
        doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
        const tableStartY = titleY + 10;
        const headers = [['Ledger', 'Opening', 'Debit', 'Credit', 'Closing']];
        const rows = ReportData.map(item => [
            item.le_ledgername,
            parseFloat(item.opening_balance || 0).toFixed(2),
            parseFloat(item.total_debit || 0).toFixed(2),
            parseFloat(item.total_credit || 0).toFixed(2),
            parseFloat(item.closing_balance || 0).toFixed(2)
        ]);
        doc.autoTable({
            head: headers,
            body: rows,
            startY: tableStartY,
            theme: 'striped',
            didDrawPage: function (data) {
                var str = "Page " + doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
            }
        });
        doc.save('GeneralLedgerSummary.pdf');
    };
    onchangedateHandler = (event) => {
        let selectedOption = event.target.value;
        const periodMap = {
            'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
            'This Quarter': [dayjs().startOf('quarter'), dayjs().endOf('quarter')],
            'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
            'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
            'Last Quarter': [dayjs().subtract(1, 'quarter').startOf('quarter'), dayjs().subtract(1, 'quarter').endOf('quarter')],
            'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
            'Custom': [dayjs(), dayjs()]
        };
        if (selectedOption === 'Custom') {
            this.setState({
                fromdate: periodMap.Custom[0],
                todate: periodMap.Custom[1],
                fromdate1: periodMap.Custom[0].format('YYYY-MM-DD'),
                todate1: periodMap.Custom[1].format('YYYY-MM-DD'),
                fromDateEnabled: true,
                toDateEnabled: true
            });
        } else {
            this.setState({
                fromdate: periodMap[selectedOption][0],
                todate: periodMap[selectedOption][1],
                fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
                todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
                fromDateEnabled: false,
                toDateEnabled: false
            });
        }
    };
openLedgerDetail = (ledgerId) => {
    const { fromdate1, todate1 } = this.state;

    window.location.hash = `/GeneralLedgerReport?ledger_id=${ledgerId}&fromdate=${fromdate1}&todate=${todate1}`;
};
    render() {
      
        const { ReportData, page, rowsPerPage, totaldata, isselectdisplay } = this.state;
        const headCells = [
            { id: 'le_ledgername', numeric: false, label: 'Ledger' },
            { id: 'opening_balance', numeric: true, label: 'Opening' },
            { id: 'total_debit', numeric: true, label: 'Debit' },
            { id: 'total_credit', numeric: true, label: 'Credit' },
            { id: 'closing_balance', numeric: true, label: 'Closing' },
        ];
        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul>
                        <li>
                            <p>Ledger</p>
                            <p>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    className="txtbox"
                                    value={this.state.ledgerName}
                                    id="ledgerName"
                                    inputProps={{ tabIndex: "1", maxLength: 150 }}
                                    name="ledgerName"
                                    onChange={this.myChangeHandler}
                                    InputProps={{
                                        endAdornment: (
                                            <SearchOutlinedIcon style={{ marginLeft: 8 }} />
                                        ),
                                    }}
                                />
                            </p>
                        </li>
                        <li>
                            <p>Period</p>
                            <p>
                                <Select native className="txtbox" onChange={this.onchangedateHandler}>
                                <option>This Month</option>
                                <option>This Quarter</option>
                                <option>This Year</option>
                                <option>Last Month</option>
                                <option>Last Quarter</option>
                                <option>Last Year</option>
                                <option>Custom</option>
                            </Select>
                            </p>
                        </li>
                        <li>
                            <p>From Date</p>
                            <p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disabled={!this.state.fromDateEnabled}
                                            value={this.state.fromdate}
                                            className="txtbox"
                                            onChange={this.fromdatehandler}
                                            format="MM/DD/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </p>
                        </li>
                        <li>
                            <p>To Date</p>
                            <p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disabled={!this.state.toDateEnabled}
                                            value={this.state.todate}
                                            className="txtbox"
                                            onChange={this.todatehandler}
                                            format="MM/DD/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </p>
                        </li>                 
                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="frmSecondarybtn"
                                    onClick={this.handleClickSearch}
                                >
                                    Calculate
                                </Button>
                                &nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog}
                                >
                                    EXPORT
                                </Button>
                            </p>
                        </li>
                    </ul>
                </div>
                <div className="clear"></div>
                <Paper>
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table" id="ledgerTable">
                            <TableHead>
                                <TableRow>
                                    {headCells.map((headCell) => (
                                        <TableCell
                                            key={headCell.id}
                                            align={headCell.numeric ? 'left' : 'left'}
                                            padding={'default'}
                                        >
                                            <b>{headCell.label}</b>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {totaldata === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={headCells.length} align="center">
                                            <h3>No Records</h3>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    ReportData.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell                                                
                                               style={{ cursor: 'pointer', textDecoration: 'none' }}
                                                onClick={() => this.openLedgerDetail(item.le_id)}
                                            >
                                                {item.le_ledgername}
                                            </TableCell>
                                           <TableCell                                                
                                               style={{ cursor: 'pointer', textDecoration: 'none' }}
                                                onClick={() => this.openLedgerDetail(item.le_id)}
                                            >{parseFloat(item.opening_balance || 0).toFixed(2)}</TableCell>
                                            <TableCell                                                
                                               style={{ cursor: 'pointer', textDecoration: 'none' }}
                                                onClick={() => this.openLedgerDetail(item.le_id)}
                                            >{parseFloat(item.total_debit || 0).toFixed(2)}</TableCell>
                                           <TableCell                                                
                                               style={{ cursor: 'pointer', textDecoration: 'none' }}
                                                onClick={() => this.openLedgerDetail(item.le_id)}
                                            >{parseFloat(item.total_credit || 0).toFixed(2)}</TableCell>
                                            <TableCell                                                
                                               style={{ cursor: 'pointer', textDecoration: 'none' }}
                                                onClick={() => this.openLedgerDetail(item.le_id)}
                                            ><b>{parseFloat(item.closing_balance || 0).toFixed(2)}</b></TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[50, 100, 200, 300, 400]}
                        component="div"
                        count={totaldata}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </Paper>
                <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Export General Ledger Summary</DialogTitle>
                    <DialogContent>
                        <p>Choose the format below.</p>
                        <p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
                            <ReactHTMLTableToExcel
                                variant="contained"
                                color="primary"
                                id="test-table-xls-button"
                                className="my-custom-excel-button"
                                table="ledgerTable"
                                filename="General Ledger Summary" 
                                sheet="General Ledger Summary" 
                            />
                            <img
                                src={psdfimage}
                                width={100}
                                height={100}
                                style={{ cursor: "pointer" }}
                                onClick={this.handleDownload}
                                alt="Download PDF"
                            />
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}